import React from "react";
import "./Services.css";
import { faVideo, faCalendarCheck, faHeartPulse, faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const Services: React.FC = () => {
  const { t } = useTranslation();
  const icons = [faVideo, faCalendarCheck, faHeartPulse, faHouse];
  const serviceData = t("services.items", { returnObjects: true }) as { title: string; description: string }[];

  const colors = ["#000043", "#28a745", "#ffc107", "#1a237e"];
  const targetIds = ["teleconsultation", "appointment-section", "biocapteurs", "soins-domicile"];

  const scrollToSection = (targetId: string) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="services">
      <div className="container">
        <h2 >{t("services.title")}</h2>
        <div className="services-grid">
          {serviceData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="title-container">
                <div className="service-icon" style={{ backgroundColor: colors[index] }}>
                  <FontAwesomeIcon icon={icons[index]} />
                </div>
                <h3  >{service.title}</h3>
              </div>
              <p>{service.description}</p>
              <button 
                className="learn-more-btn"
                onClick={() => scrollToSection(targetIds[index])}
              >
                {t("services.button")}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
